import { getFlyerCustomLabel, getSectionFromTableOfContentsByPage } from 'utils'

const PRECISION_IN_MS = 500

export function formatDate(timestamp) {
  const date = new Date(timestamp)

  const roundedTime = Math.round(date.getMilliseconds() / PRECISION_IN_MS) * PRECISION_IN_MS
  date.setMilliseconds(roundedTime)

  return date.toISOString()
}

export const eventFields = {
  gib: {
    getProductCode: (flyerGib) => ({
      product_code: flyerGib?.settings?.customer_product_id || '',
    }),
  },
  tag: {
    getProductName: (tag) => ({
      product_name: tag?.title || '',
    }),
    getFullPrice: (tag) => ({ 
      full_price: tag?.initialPrice || '',
    }),
    getDiscountedPrice: (tag) => ({ 
      discounted_price: tag?.price || '',
    }),
  },
  flyer: {
    getCustomLabel: (flyer) => ({
      custom_label: getFlyerCustomLabel(flyer) || '',
    }),
    getSection: (flyer, pageNumber) => {
      const section = getSectionFromTableOfContentsByPage(flyer, pageNumber)
      
      return {
        section: section?.label || '',
      }
    },
  },
  pageNumber: {
    getPageNumber: (flyerPage) => ({
      page_number: flyerPage || '',
    }),
  },
  date: {
    getOriginalTimestamp: () => ({
      original_timestamp: formatDate(Date.now()),
    }),
  },
}
